//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/ScCollector.js";
let d=[[[0,"BridgeGap",1,0],[0,"ByColor",1,0],[0,"EndEdge",1,0],[0,"ExitLoop",1,0],[1,"SelectEdge",0,"ScCollector",0],[0,"TolSetting",1,0]],[[[],"ActBack",{},0,0],[[],"ActAccept",{},0,0],[[],"ActCycle",{},0,0],[[],"ActClose",{},0,0],[[],"ActExit",{},0,0],[["pTolSelObject","selections","deselections","cpoint","selectEndEdge"],"ActEdgeSelection",{},5,0],[[],"ResetTraverseData",{},0,0],[["pPartingLines"],"MoveCurves",{},1,0],[[],"SwitchToPartinglineLayer",{},0,0],[["candidate","pointCloseCursor","selections"],"SetTraverseStartEndPoint",{},3,0],[["selections","nearPoint"],"CheckGap",{R_:{gap:''}},1,0]],[]];
SPLM.Tooling.TraverseLoopBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.TraverseLoopBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;